export default "__VITE_ASSET__3bee9781__"